import { render, staticRenderFns } from "./FormRepeatTask.vue?vue&type=template&id=0bb50230&scoped=true"
import script from "./FormRepeatTask.vue?vue&type=script&lang=js"
export * from "./FormRepeatTask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb50230",
  null
  
)

export default component.exports